import React from 'react';
import classnames from 'classnames';

import styles from './Switch.module.scss';

interface IOption {
  text: string;
  value: string;
}

interface IProps {
  options: IOption[];
  value: string;
  className?: string;
  onChange?: (opt: IOption) => void;
}

function Switch(props: IProps) {
  const { options, value, className, onChange } = props;

  const handleClick = (opt: IOption) => {
    onChange?.(opt);
  };

  return (
    <div className={classnames(styles.container, className)}>
      <div style={{ fontSize: 0, borderRadius: 4 }} className={styles.optionsWrap}>
        {(options || []).map((opt) => {
          return (
            <a
              key={opt.value}
              onClick={() => handleClick(opt)}
              className={classnames(styles.option, { [styles.optionActive]: opt.value === value })}
            >
              {opt.text}
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default Switch;
